import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    addRow: 'Add another line',
    amount: 'VAT’s amount',
    rate: 'Rate',
  },
  fr: {
    addRow: 'Ajouter une ligne',
    amount: 'Montant de la TVA',
    rate: 'Taux',
  },
} as const);

export default locales;
